import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MemberService } from '../shared/services/member.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PusherService } from 'src/services/pusher-service.service';
import { MatDialog } from '@angular/material/dialog';
import { WhiteSpaceValidator } from '../shared/validators/white-space-validator';
import * as moment from 'moment';
import 'moment-timezone';
import { MatTableDataSource } from '@angular/material/table';
declare var $: any;
declare const Pusher: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit {
  typeofSharePoint:string='';
  addMemberForm = false;
  memberSubmitted = false;
  isLoading = false;
  isusersubmitted: boolean = false;
  member: any;
  UserDtls: any;
  selectedGroups: number[] = [];
  html = '<p></p>';
  customvalidator:boolean=false;
  validTypes=  ['image/jpeg', 'image/png', 'image/gif'];
  logoHide: boolean = true;
  isShow:boolean=true;
  logoDisplay: string;
  token: string;
  roleList: any;
  selectedFile:File=null;
  title: any;
  rolevalue: any;
  formheading: string = '';
  memberForm: FormGroup;
  onselect: boolean = false;
  catagoryDropDown: any[];
  subCatagoryDropDown:any[]=[];
  isPresent: boolean=false;
  subcategoryDropDowns: any[];
  subCatagoryDropDowns: any;
  displayedColumns: string[] = [
    "userName",
    "email",
    "designation",
    //"companyName",
    "date"
  ];
  
  dataSource: MatTableDataSource<any>;
  dataSourceAnnouncement: MatTableDataSource<any>;
  dataSourceSharepoint:MatTableDataSource<any>;
  roleTypes = [];
  currentUser: any;
  organizationName: any;
  orgId: any;
  VendorGroupArray: any;
  groupList: any;
  groupDropDown: any;
  addAnnouncementForm: boolean;
  subcategoryMap: any[];
  categoryMap: any[];
  allhideSub: boolean;
  vendorMap: any[];
  allhide: boolean;
  typeofAnnounce: string;
  announcementId: number;
  selectedRoles: any[];
  apiselectedRoles: any[];
  announcementSubmit: boolean;
  isSelectedRoles: boolean;
  announcementForm: FormGroup;
  Allvendormap: any[]=[];
  AllSubcategoryMap: any[]=[];
  userRoles: any[]=[];
  allhideSubAll: boolean;
  allhidegroupAll: boolean;
  userTypeMap: any;
  isFalse=false;
  sharePointSubmit: boolean;
  sharePointForm: FormGroup;
  sharePointLInkId: number;
  helpDeskcount: number=0;
  completedCount=0;
  progressCount=0;
  isShowList:boolean=false;
  dashboardList: any;
  annoncementCount: number=0;
  users: any[];
  Membercounts:any={
    "totalCount":0,
    "active":0,
    "inActive":0,
    "deleted":0
  };
  AnnouncementCount:any={
    "totalCount":0,
    "active":0,
    "inActive":0,
    "deleted":0
  };
  SharePointCount:any={
    "totalCount":0,
    "active":0,
    "inActive":0,
    "deleted":0
  };
  members: any[]=[];
  sharepoint: any[]=[];
  annviewedCount=0;
  helpDeskYetToAssignCount: any;
  helpDeskAssignedCount: any;
  helpDeskOnHoldCount: any;
  helpDeskCancelledCount: any;
  categoryDropDown: any;
  filterGeneral: any[];
  usertypeList: any[]=[];
  categoryCount: any[]=[];
  totalUsertypeCount: any;
  totalCategoryCount: any;


  constructor(
        private memberService: MemberService,
        private router: Router,
        private formBuilder: FormBuilder,
        private spinnerService: NgxSpinnerService,
        private pusherService: PusherService,
        public dialog: MatDialog,
        private renderer: Renderer2,
        private route: ActivatedRoute
  ) {
    
    let user = JSON.parse(localStorage.getItem("currentUser"));
    this.token = "Bearer" + " " + user.jwtToken;
    this.organizationName = user.organaisationName;
    this.orgId=user.organaisationId;
    
    this.announcementForm = this.formBuilder.group({
      title: ['', [Validators.required, WhiteSpaceValidator, Validators.pattern(/^.{2,}$/)]],
      // rolevalue: ['', Validators.required],
      html: ['', [Validators.required, WhiteSpaceValidator]],
      shortTitle:['', [Validators.required, WhiteSpaceValidator, Validators.pattern(/^.{2,}$/)]],
      sharePointLink: ['', [Validators.pattern(/^(http:\/\/|https:\/\/).+$/)]],
      shortDescription:['', [Validators.required, WhiteSpaceValidator, Validators.pattern(/^.{2,}$/)]],
      logoimg:['',[Validators.required, WhiteSpaceValidator]],
      groupId:[[],[]],
      catagory:[0,[]],
      subcatogorycatagory:[[],[]]
    });

    this.sharePointForm = this.formBuilder.group({
      title: ['', [Validators.required, WhiteSpaceValidator]],
      html: ['', [Validators.required, Validators.pattern(/^(http:\/\/|https:\/\/).+$/), WhiteSpaceValidator]],
      notes: ['', [WhiteSpaceValidator, Validators.maxLength(150)]],
      interests: this.formBuilder.array([]),
      groupId:[[],[]],
      catagory:[0,[]],
      subcatogorycatagory:[[],[]]
    });
    
  }
  showList():boolean{
    // this.isShow=false;
    // console.log('True',this.isShow);
    this.isFalse=!this.isFalse;
    return true;
  }
  ngOnInit(): void {
   const now = moment();
    let dateTimeInfo = {
      // dateTimeOnUtc: now.utc().format('YYYY-MM-DDTHH:mm:ss[Z]'), // UTC Date-Time in ISO format
      currentDateTime: now.format('YYYY-MM-DDTHH:mm:ss[Z]'), // Local Date-Time in ISO format
      // timeZoneName: Intl.DateTimeFormat().resolvedOptions().timeZone, // Time Zone Name
      timeZoneGMT: now.format('Z') // GMT Offset (e.g., "-07:00")
    };
     this.GetVendorGroupList();
    this.getRoles()
    this.getCatogoryList();
    this.postAdminDashboard(dateTimeInfo);
    // this.getMembers(1,5,'',0);
    this.QuickAnnouncementList();
    this.QuickMemberList();
    this.QuickSharePointList();

    console.log('Help Desk Count ',this.helpDeskcount)
    
  }
  // getCatogoryList(){
  //   this.spinnerService.show();
  //   this.memberService
  //   .getCatogoryList( this.token)
  //   .subscribe(
  //     (data: any) => {
  //       if (data.statusCode === 200) {
  //         this.categoryDropDown=data.categoryLists.map(category => ({
  //           categoryId: category.categoryId,
  //           categoryName: category.categoryName,
  //           subCategories: category.subCategoryList.map(subCat => ({
  //               categoryId: subCat.categoryId,
  //               categoryName: subCat.categoryName
  //           }))
  //       }));
  //         this.catagoryDropDown= data.categoryLists.filter((value)=>!value.isGeneral);
  //         this.catagoryDropDown=this.catagoryDropDown.map(value=>({
  //           categoryName:value.categoryName,
  //           categoryId:parseInt(value.categoryId),
  //         })
  //         );
  //         this.subCatagoryDropDowns = data.categoryLists.map((value=>value.subCategoryList));
  //         this.subCatagoryDropDowns = data.categoryLists
  //         .map(value => value.subCategoryList) // Extract subCategoryList arrays
  //         .flat() // Flatten the array of arrays into a single array
  //         .map(value => ({
  //           categoryName: value.categoryName,
  //           categoryId: parseInt(value.categoryId),
  //           parentCategoryId: parseInt(value.parentCategoryId)
  //         })); 
          
        
  //       ////console.log('usb',this.subCatagoryDropDowns)

  //         // this.groupList= data.vendorGroupList.map(group => ({
  //         //   id: group.groupId,
  //         //   name: group.name,
  //         // }));
  //        ////console.log('data -------> ',this.catagoryDropDown);
  //         return;
  //       }
  //     },
  //     err => {
  //       if (err.status === 401) {
  //         this.unauthorizedException();
  //       }
  //     }
  //   );
  // }
  getUsertype(value:any[]){
    value=value.map((value=>value.roleName))
    return value.join();
  }
  
  QuickAnnouncementList(){
   
  //  this.dataSourceAnnouncement= new MatTableDataSource(sampleData);
   
    this.spinnerService.show();
    let params={
      "roleId": 0,
      "pageNo": 1,
      "pageSize": 5
    }
    this.memberService.QuickAnnouncementList(params,this.token).subscribe(
      (data: any) => {
        // this.ishubspotLoading = false;
        if (data.statusCode == 200) {
          console.log(data.statusCode)
          setTimeout(() => {
            this.spinnerService.hide();
          }, 800)
          // let userData = this.getMemberListArray(data.memberList);
          this.users = data.announcementList;
          // console.log('Users', this.users);
          
          this.dataSourceAnnouncement = new MatTableDataSource(this.users);
          this.AnnouncementCount.isActive=data.announcementActiveCount
          console.log('MemberCount',data.filteredCount);
          this.AnnouncementCount.totalCount=data.announcementTotalCount;
          console.log('Total',data.totalCount);
          this.AnnouncementCount.inActive=data.announcementDeletedCount;
          // this.dataSource.paginator = this.paginator;
          // this.totalItems = data.filteredCount
          // this.dataSource.sort = this.sort;
          this.spinnerService.hide();
        }
        else {
          this.isLoading = false;
          Swal.fire({
            title: data.statusMessage,
            icon: "warning",
            showCloseButton: true,
            allowOutsideClick: false
          });
          this.spinnerService.hide();

        }
      },
      err => {
        if (err.status === 401) {
          this.spinnerService.hide();
          this.unauthorizedException();
        }
      }
    );

  }
  QuickMemberList(){
    this.spinnerService.show();
  // this.dataSource = new MatTableDataSource(SampleMember);
    let params={
      "filterRoleType": 0,
      "pageNo": 1,
      "pageSize": 5
    }
    this.memberService.QuickMemeberList(params,this.token).subscribe(
      (data: any) => {
        // this.ishubspotLoading = false;
        if (data.statusCode == 200) {
          console.log(data.statusCode)
          setTimeout(() => {
            this.spinnerService.hide();
          }, 800)
          // let userData = this.getMemberListArray(data.memberList);
          this.members = data.memberList;
          this.usertypeList=data.userTypeCount;
          this.categoryCount=data.categoryCount;
          // console.log('Users', this.users);
          // this.dataSource = new MatTableDataSource(this.members);
         
          this.Membercounts.isActive=data.activeCount
          console.log('MemberCount',data.filteredCount);
          this.Membercounts.totalCount=data.totalCount;
          console.log('Total',data.totalCount);
          this.Membercounts.inActive=data.inactiveCount;
          this.Membercounts.deleted=data.deletedCount;
          this.totalUsertypeCount=data.totalUsertypeCount;
          this.totalCategoryCount=data.totalCategoryCount;
          // this.dataSource.paginator = this.paginator;
          // this.totalItems = data.filteredCount
          // this.dataSource.sort = this.sort;
        }
        else {
          this.isLoading = false;
          Swal.fire({
            title: data.statusMessage,
            icon: "warning",
            showCloseButton: true,
            allowOutsideClick: false
          });
          this.spinnerService.hide();

        }
      },
      err => {
        if (err.status === 401) {
          this.spinnerService.hide();
          this.unauthorizedException();
        }
      }
    );

  }

  CountDisplay(type: string, id: any): number {
    if (type === 'usertype' && Array.isArray(this.usertypeList)) {
      let result = this.usertypeList
        .filter(value => value.userTypeId == id)
        .map(value => value.usertypeCount);
      
      return result.length > 0 ? result[0] : 0; // Ensure it never returns undefined
    } 
    else if (type === "category" && Array.isArray(this.categoryCount)) {
      let result = this.categoryCount
        .filter(value => value.categoryId == id)
        .map(value => value.categoryCount);
      
      return result.length > 0 ? result[0] : 0; // Ensure it never returns undefined
    }
  
    return 0; // Default return value in case of an unknown type
  }
  

  QuickSharePointList(){
    this.spinnerService.show();
   // this.dataSourceSharepoint= new MatTableDataSource(sampleData);
    let params={
      "filterRoleType": 0,
      "pageNo": 1,
      "pageSize": 5
    }
    this.memberService.QuickSharepointList(params,this.token).subscribe(
      (data: any) => {
        // this.ishubspotLoading = false;
        if (data.statusCode == 200) {
          console.log(data.statusCode)
          setTimeout(() => {
            this.spinnerService.hide();
          }, 800)
          // let userData = this.getMemberListArray(data.memberList);
          this.sharepoint = data.sharePointLists;
          // console.log('Users', this.users);
          this.dataSourceSharepoint = new MatTableDataSource(data.sharePointLists);
          this.SharePointCount.isActive=data.sharepointActiveCount
          console.log('MemberCount',data.filteredCount);
          this.SharePointCount.totalCount=data.sharepointTotalCount;
          console.log('Total',data.totalCount);
          this.SharePointCount.inActive=data.sharepointDeletedCount;
          this.SharePointCount.deleted=data.sharepointDeletedCount;
          
          // this.dataSource.paginator = this.paginator;
          // this.totalItems = data.filteredCount
          // this.dataSource.sort = this.sort;
        }
        else {
          this.isLoading = false;
          Swal.fire({
            title: data.statusMessage,
            icon: "warning",
            showCloseButton: true,
            allowOutsideClick: false
          });
          this.spinnerService.hide();

        }
      },
      err => {
        if (err.status === 401) {
          this.spinnerService.hide();
          this.unauthorizedException();
        }
      }
    );
  }
  saveSharePoint() {
      this.sharePointSubmit = true;
      console.log(this.sharePointForm)
      if (this.selectedRoles.length === 0 || this.sharePointForm.invalid) {
        this.isSelectedRoles = true;
  
        if (this.selectedRoles.length > 0) {
          this.isSelectedRoles = false;
          return;
        }
  
        if (this.sharePointForm.invalid) {
          return;
        }
  
        return; // Return if either condition is true
      }
      this.sharePointSubmit = false;
      
      // console.log('Params',params);
      let user = JSON.parse(localStorage.getItem("currentUser"));
      let token = "Bearer" + " " + user.jwtToken;
      this.spinnerService.show();
  
      if (this.sharePointLInkId == 0) {
        let subcategoryIdArray=[];
        if(this.sharePointForm.value.subcatogorycatagory!=''){
        subcategoryIdArray.push(parseInt(this.sharePointForm.value.subcatogorycatagory));
        }
        let vendorgroupIdArray=[];
       if( this.sharePointForm.value.groupId!=''){
        vendorgroupIdArray.push(parseInt(this.sharePointForm.value.groupId))
       }
       let params = {
        "title": this.sharePointForm.value.title,
        "userTypeId": this.userRoles,
        "link": this.sharePointForm.value.html,
        "notes": this.sharePointForm.value.notes,
        "parentCategoryId":this.sharePointForm.value.catagory,
        "subCategoryId":this.allhideSub?this.AllSubcategoryMap:this.sharePointForm.value.subcatogorycatagory,
        "vendorgroupId":this.allhide?this.Allvendormap:this.sharePointForm.value.groupId
  
      }
      console.log('params',params);
  
        this.memberService
          .PostSendSharePoints(params, token)
          .subscribe(
            (data: { statusCode: Number; statusMessage: string }) => {
              if (data.statusCode === 200) {
                this.spinnerService.hide();
                // this.addAnnouncementForm = false;
                Swal.fire({
                  icon: "success",
                  title: "Created Successfully",
                  showCloseButton: true,
                  allowOutsideClick: false
                })
                  $("#newformCreate").modal("hide");
                  this.sharePointSubmit = false;
                  this.ngOnInit();
                  // this.getsharePointLists(this.currentPage + 1, this.pageSize, this.searchKey, 0);
                  
               
                return;
              }
              else{
                Swal.fire({
                  icon: "warning",
                  title: data.statusMessage,
                  showCloseButton: true,
                  allowOutsideClick: false
                })
                this.spinnerService.hide();

              }
             
            },
            err => {
              if (err.status === 401) {
                this.unauthorizedException();
              }
            }
          );
      }
     
    }
  
  onSelectGroups(groups: any[],select:string ) {
      if(groups.length!=0 &&  select=='sub' && !groups.includes('all') ){
      this.allhideSubAll=true;
      return;
      }
      if(groups.length!=0 &&  select=='group' && !groups.includes('all') ){
        this.allhidegroupAll=true;
        return;
        }
      this.allhideSubAll=false;
      this.allhidegroupAll=false;
      if (groups.includes('all') && select=='group') {
        let map=this.groupList.map((value)=>value.id);
        this.allhide=true;
        console.log('All',map);
        // console.log('Map',map);
        this.Allvendormap=map;
        // If "All" is selected, do nothing and prevent further actions
        return;
      }
      else if(groups.includes('all') && select=='sub'){
        let map=this.subCatagoryDropDown.map((value)=>value.categoryId);
        this.allhideSub=true;
        this.AllSubcategoryMap=map;
        console.log('map sub ',map);
      }
      else{
   
        this.allhide=false;
        this.allhideSub=false;
        console.log('Mpa', this.AllSubcategoryMap)
        
  
      }
      console.log('All',this.allhide);
      // Your normal selection logic for individual items
      console.log('Selected Groups:', groups);
    }
  saveAnnouncement() {
      this.announcementSubmit = true;
  
      if (this.selectedRoles.length === 0 || this.announcementForm.invalid) {
        this.isSelectedRoles = true;
  
        if (this.selectedRoles.length > 0) {
          this.isSelectedRoles = false;
          return;
        }
  
        if (this.announcementForm.invalid) {
          return;
        }
  
        return; // Return if either condition is true
      }
      if(!this.logoHide){
      this.customvalidator= ! this.validTypes.includes(this.selectedFile.type);
      if(! this.validTypes.includes(this.selectedFile.type)){
       
       return;
  
      }
    }
      let params = {
        "title": this.announcementForm.value.title,
        "content": this.announcementForm.value.html,
        "userTypeId": this.userRoles,
        "adminId": 1,
        "announcementId": this.announcementId,
        "shortDescription":this.announcementForm.value.shortDescription,
        "shortTitle":this.announcementForm.value.shortTitle,
        "announcementImage":this.selectedFile,
        "parentCategoryId":this.announcementForm.value.catagory==''?0:this.announcementForm.value.catagory,
        "subCategoryId":!this.isPresent?0:this.announcementForm.value.subcatogorycatagory,
        "vendorgroupId":this.announcementForm.value.groupId==''?0:this.announcementForm.value.groupId
      }
      console.log('Params',params);
      
      // return;
      let param =new FormData();
      param.append("title", this.announcementForm.value.title);
      param.append("content", this.announcementForm.value.html);
      console.log(this.selectedRoles);

      this.userRoles.forEach((role) => {
        param.append("userTypeId", role);  // Sends multiple roleId values
      });
      param.append("adminId", "1");
      param.append("shortDescription",this.announcementForm.value.shortDescription);
      param.append("sharePointLink",this.announcementForm.value.sharePointLink);
      param.append("shortTitle",this.announcementForm.value.shortTitle);
      param.append("announcementImage",this.selectedFile);
      param.append("parentCategoryId",this.announcementForm.value.catagory==''?0:this.announcementForm.value.catagory);
      if(this.isPresent){
      //  param.append("subCategoryId", this.announcementForm.value.subcatogorycatagory);
       if(this.allhideSub){
       this.AllSubcategoryMap.forEach((role)=>{
        param.append("subCategoryId",role);
       });
      }
      else{
        this.announcementForm.value.subcatogorycatagory.forEach((role)=>{
          param.append("subCategoryId",role);
         });
      }
      
      }
      console.log('Ann',)
      
        if( this.allhide){
       this.Allvendormap.forEach((role)=>{
        param.append("vendorgroupId",role);
       });
      }
      else{
        this.announcementForm.value.groupId.forEach((role)=>{
          param.append("vendorgroupId",role);
         });
      
      
      }
    //   if (!this.isPresent || this.announcementForm.value.subcatogorycatagory!='') {
    //     param.append("subCategoryId[]", ""); // Append an empty string for empty array
    // } else {
    //     this.announcementForm.value.subcatogorycatagory.forEach((id) => {
    //         param.append("subCategoryId[]", id); // Append each element
    //     });
    // } 
  
      // Append vendorgroupId
  // if (!this.announcementForm.value.groupId || this.announcementForm.value.groupId === '') {
  //   param.append("vendorgroupId[]", ""); // Append an empty value for an empty array
  // } else {
  //   this.announcementForm.value.groupId.forEach((id) => {
  //       param.append("vendorgroupId[]", id); // Append each element of the array
  //   });
  // }
      console.log('param',param);
      
      param.forEach((value, key) => {
      console.log('key   ' + key + 'value  ' + value);
      });
      let user = JSON.parse(localStorage.getItem("currentUser"));
      let token = "Bearer" + " " + user.jwtToken;
      
      this.spinnerService.show();
  
      if (this.announcementId == 0) {
        this.memberService
          .PostSendAnnouncement(param, token)
          .subscribe(
            (data: { statusCode: Number; statusMessage: string }) => {
              if (data.statusCode === 200) {
                this.spinnerService.hide();
                $("#newAnnouncementCreate").modal("hide");
                this.addAnnouncementForm = false;
                Swal.fire({
                  icon: "success",
                  title: " Announcement Created Successfully",
                  
                  showCloseButton: true,
                  allowOutsideClick: false
                }).then(() => {
                  this.ngOnInit()
                });
                return;
              }
              else{
                Swal.fire({
                  icon: "warning",
                  title: data.statusMessage,
                  showCloseButton: true,
                  allowOutsideClick: false
                })
                this.spinnerService.hide();

              }
             
            },
            err => {
              if (err.status === 401) {
                this.unauthorizedException();
              }
            }
          );
      }
      
  }

  openAddAnnounceModal() {
     
      this.subcategoryMap=[];
      this.categoryMap=[];
      // this.allhideSub=false;
      this.subCatagoryDropDown=[];
      this.vendorMap=[];
      this.categoryMap=[];
      this.subcategoryMap=[];
      // this.allhide=false;
      this.isPresent=false;
      this.customvalidator=false;
      this.logoHide=true;
      this.isShow=true;
      this.addAnnouncementForm = true;
      this.typeofAnnounce = "Create"
      this.announcementId = 0
      $("#newAnnouncementCreate").modal("show");
      this.selectedRoles = []
      this.apiselectedRoles = []
      this.announcementSubmit = false;
      this.isSelectedRoles = false;
      this.announcementForm = this.formBuilder.group({
        title: ['', [Validators.required, WhiteSpaceValidator, Validators.pattern(/^.{2,}$/)]],
        // rolevalue: ['', Validators.required],
        html: ['', [Validators.required, WhiteSpaceValidator]],
        shortTitle:['', [Validators.required, WhiteSpaceValidator, Validators.pattern(/^.{2,}$/)]],
        sharePointLink: ['', [Validators.pattern(/^(http:\/\/|https:\/\/).+$/)]],
        shortDescription:['', [Validators.required, WhiteSpaceValidator, Validators.pattern(/^.{2,}$/)]],
        logoimg:['',[Validators.required, WhiteSpaceValidator]],
        groupId:[[],[]],
        catagory:[0,[]],
        subcatogorycatagory:[[],[]]
      });
  
    }
  getCatogoryList(){
    this.memberService
    .getCatogoryList( this.token)
    .subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.catagoryDropDown=data.categoryLists.filter((value)=>value.isGeneral!=1);
          this.filterGeneral=data.categoryLists.filter((value)=>value.isGeneral!=1).map(value=>({
            categoryName:value.categoryName,
            categoryId:parseInt(value.categoryId),
          })
          );
          this.catagoryDropDown=this.catagoryDropDown.map(value=>({
            categoryName:value.categoryName,
            categoryId:parseInt(value.categoryId),
          })
          );
        
          this.subCatagoryDropDowns = data.categoryLists.map((value=>value.subCategoryList));
          
          this.subCatagoryDropDowns = data.categoryLists
          .map(value => value.subCategoryList) // Extract subCategoryList arrays
          .flat() // Flatten the array of arrays into a single array
          .map(value => ({
            categoryName: value.categoryName,
            categoryId: parseInt(value.categoryId),
            parentCategoryId: parseInt(value.parentCategoryId)
          })); 
          
        
        console.log('usb',this.subCatagoryDropDowns)

          // this.groupList= data.vendorGroupList.map(group => ({
          //   id: group.groupId,
          //   name: group.name,
          // }));
         console.log('data -------> ',this.catagoryDropDown);
          return;
        }
      },
      err => {
        if (err.status === 401) {
          this.unauthorizedException();
        }
      }
    );
  }
  routeredirection(route){
    this.router.navigate(['/'+route])
  }
  goto(id) {
    
    // if (id == 1)
    //   this.router.navigate(['/organization'])
    // else if (id == 2)
    //   this.router.navigate(['/manageSubscription'])
    // else if (id == 3)
    //   this.router.navigate(['/manageSubscription'])
    // else if (id == 4)
    //   this.router.navigate(['/organization'])
  }
  onFileSelect(event: any) {
    this.logoHide = false;
    if(this.announcementSubmit==true||this.validTypes.includes(event.target.files[0].type)){
    this.customvalidator= ! this.validTypes.includes(event.target.files[0].type);
    }
    this.selectedFile = event.target.files[0];
      // Resize the image and get it as a Blob
      // this.resizeImage(this.selectedFile ,622, 700).then((blob) => {
      //   this.resizedBlob = blob; // Now we have the resized Blob
      // });
    
  }
  hide() {
    $("#newMemberCreate").modal("hide");
    this.addMemberForm = false;
    this.isLoading = false;
    this.memberSubmitted = false;
    this.addAnnouncementForm = false;
    this.announcementSubmit = false;
    this.isSelectedRoles = false;
    $("#newAnnouncementCreate").modal("hide");
    $("#newformCreate").modal("hide");
  }
  postAdminDashboard(params:any){
  // let params={
    
  //     "dateTimeOnUtc": this.utcDateTime,
  //     "currentDateTime": this.localDateTime,
  //     "timeZoneName": this.timeZoneName,
  //     "timeZoneGMT":this.timeZoneGmt
  
  // }
  this.memberService
    .postAdminDashboard( params,this.token)
    .subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          console.log('data',data);
        this.dashboardList=data;
        this.helpDeskcount=this.dashboardList.helpDeskTodayCount;
        this.helpDeskYetToAssignCount=this.dashboardList.helpDeskYetToAssignTodayCount;
        this.helpDeskAssignedCount=this.dashboardList.helpDeskAssignedTodayCount;
        this.helpDeskOnHoldCount=this.dashboardList.helpDeskOnHoldTodayCount;
        this.helpDeskCancelledCount=this.dashboardList.helpDeskCancelledTodayCount;
        this.completedCount=this.dashboardList.helpDeskCompletedTodayCount;
        this.annoncementCount=this.dashboardList.announcementTodayCount;
        this.progressCount=this.dashboardList.helpDeskActiveTodayCount;
        this.annoncementCount=this.dashboardList.announcementTodayCount;
        this.annviewedCount=this.dashboardList.announcementViewedTodayCount;
        }
      },
      err => {
        if (err.status === 401) {
          this.unauthorizedException();
        }
      }
    );

  }
  onSelectionChange(event: Event,key): void {
  
    const selectedValue = (event.target as HTMLSelectElement).value;
    if(key=='HelpDesk'){
    if(selectedValue=='Today'){
      this.helpDeskcount=this.dashboardList.helpDeskTodayCount;
      this.completedCount=this.dashboardList.helpDeskCompletedTodayCount;
      this.progressCount=this.dashboardList.helpDeskActiveTodayCount;
       this.helpDeskYetToAssignCount=this.dashboardList.helpDeskYetToAssignTodayCount;
        this.helpDeskAssignedCount=this.dashboardList.helpDeskAssignedTodayCount;
        this.helpDeskOnHoldCount=this.dashboardList.helpDeskYetToAssignTodayCount;
        this.helpDeskCancelledCount=this.dashboardList.helpDeskCancelledTodayCount;
        this.completedCount=this.dashboardList.helpDeskCompletedTodayCount;
      
      return;
    }
    else if(selectedValue=='Week') {
      this.helpDeskcount=this.dashboardList.helpDeskWeekCount;
      this.completedCount=this.dashboardList.helpDeskCompletedWeekCount;
      this.progressCount=this.dashboardList.helpDeskActiveWeekCount;
      this.helpDeskYetToAssignCount=this.dashboardList.helpDeskYetToAssignWeekCount;
      this.helpDeskAssignedCount=this.dashboardList.helpDeskAssignedWeekCount;
      this.helpDeskOnHoldCount=this.dashboardList.helpDeskOnHoldWeekCount;
      this.helpDeskCancelledCount=this.dashboardList.helpDeskCancelledWeekCount;
      this.completedCount=this.dashboardList.helpDeskCompletedWeekCount;
      return;
    }
    else if (selectedValue=='Month'){
      this.helpDeskcount=this.dashboardList.helpDeskMonthCount;
      this.completedCount=this.dashboardList.helpDeskCompletedMonthCount;
      this.progressCount=this.dashboardList.helpDeskActiveMonthCount;
      this.helpDeskYetToAssignCount=this.dashboardList.helpDeskYetToAssignMonthCount;
      this.helpDeskAssignedCount=this.dashboardList.helpDeskAssignedMonthCount;
      this.helpDeskOnHoldCount=this.dashboardList.helpDeskOnHoldMonthCount;
      this.helpDeskCancelledCount=this.dashboardList.helpDeskCancelledMonthCount;
      this.completedCount=this.dashboardList.helpDeskCompletedMonthCount;
      return;
    }
    else{
      this.helpDeskcount=this.dashboardList.helpDeskYearCount;
      this.completedCount=this.dashboardList.helpDeskCompletedYearCount;
      this.progressCount=this.dashboardList.helpDeskActiveYearCount;
      this.helpDeskYetToAssignCount=this.dashboardList.helpDeskYetToAssignYearCount;
      this.helpDeskAssignedCount=this.dashboardList.helpDeskAssignedYearCount;
      this.helpDeskOnHoldCount=this.dashboardList.helpDeskOnHoldYearCount;
      this.helpDeskCancelledCount=this.dashboardList.helpDeskCancelledYearCount;
      this.completedCount=this.dashboardList.helpDeskCompletedYearCount;
      return;
    }
  }
  else {
    if(selectedValue=='Today'){
      this.annoncementCount=this.dashboardList.announcementTodayCount;
      this.annviewedCount=this.dashboardList.announcementViewedTodayCount;
      return;
    }
    else if(selectedValue=='Week') {
      this.annoncementCount=this.dashboardList.announcementWeekCount;
      this.annviewedCount=this.dashboardList.announcementViewedWeekCount;
      return;
    }
    else if (selectedValue=='Month'){
      this.annoncementCount=this.dashboardList.announcementMonthCount;
      this.annviewedCount=this.dashboardList.announcementViewedMonthCount;
      return;
    }
    else{
      this.annoncementCount=this.dashboardList.announcementYearCount;
      this.annviewedCount=this.dashboardList.announcementViewedYearCount;
      return;
    }

  }
    // Add your logic here, e.g., updating variables or triggering other methods
  }
  get announceControl() {
    return this.announcementForm.controls;
  }
  get shareControl(){
    return this.sharePointForm.controls;
  }
  openAddMemberModalShare() {
    
    this.getCatogoryList();
      this.vendorMap=[];
      this.subcategoryMap=[];
      this.isShow=true;
      this.isPresent=false;
      $("#newformCreate").modal("show");
      this.typeofSharePoint = "Create"
      this.addAnnouncementForm = true;
     
      this.sharePointForm = this.formBuilder.group({
        title: ['', [Validators.required, WhiteSpaceValidator]],
        html: ['', [Validators.required, Validators.pattern(/^(http:\/\/|https:\/\/).+$/), WhiteSpaceValidator]],
        notes: ['', [WhiteSpaceValidator, Validators.maxLength(150)]],
        interests: this.formBuilder.array([]),
        groupId:[[],[]],
        catagory:[0,[]],
        subcatogorycatagory:[[],[]]
      });
      this.selectedRoles = []
      this.apiselectedRoles = []
      this.sharePointLInkId = 0
    }
  memberFormSubmit() {
    this.memberSubmitted = true;
    console.log(this.memberForm)
    if (this.memberForm.invalid) {
      this.isLoading = false;
      return;
    }
    this.spinnerService.show();
    this.memberSubmitted = false;
    this.isLoading = true;
    if(!this.isPresent){
      this.memberForm.get('subCategoryId')?.setValue(0); 
    }
    console.log(this.memberForm.value);
    this.memberService.createMember(this.memberForm.value, this.token).subscribe(
      (data: any) => {
        if (data.statusCode === 201) {
          // this.isLoading = false;
          this.addMemberForm = false;
          this.isLoading = false;
          $("#newMemberCreate").modal("hide");
          
          
          Swal.fire({
            title: "Created!",
            text: "Member created successfully",
            icon: "success",
            showCloseButton: true,
            allowOutsideClick: false
          });
          this.spinnerService.hide();
          this.ngOnInit();
          
        } else {
          this.isLoading = false;
          Swal.fire({
            title: data.statusMessage,
            icon: "warning",
            showCloseButton: true,
            allowOutsideClick: false
          });
          this.spinnerService.hide();
        }
      },
      err => {
        if (err.status === 401) {
          this.unauthorizedException();
        }
      }
    );
  }
  checkAllFieldsEntered(): boolean {
    return Object.keys(this.memberForm.controls).every(controlName => {
     
       if(controlName=='parentCategoryId' && !this.isPresent ){
        return true;
      }
      else if(controlName=='subCategoryId' && this.isPresent){
        const control = this.memberForm.get(controlName);
        if(control.value==0){
          return false;
        }
        return true;
        }
       
      
      const control = this.memberForm.get(controlName);
      return control.value !== '' && control.value !== null;
    });
  }
  get memberControl() {
    return this.memberForm.controls;
  }
  onListSelect(event: any) {
    this.memberForm.patchValue({
      'roleTypes': (event.target as HTMLSelectElement).value
    });
    console.log(this.memberForm.value);

  }
  handleKeyDown(event: KeyboardEvent): void {
    console.log('Key pressed:', event.key);
    if (event.key == 'Backspace' && this.memberForm.get('phoneNo').value.length == 1) {

      this.memberForm.controls['phoneNo'].setValue('');

    }
    // Add your logic here based on the key pressed
  }
  GetVendorGroupList(){
     
      this.memberService.getVendorGroup(this.token).subscribe(
        (data: any) => {
          // this.ishubspotLoading = false;
          if (data.statusCode == 200) {
           this.VendorGroupArray=data.vendorGroupList;
           this.VendorGroupArray=this.VendorGroupArray.filter(group=>group.isActive==1); 
           this.groupList= this.VendorGroupArray.map(group => ({
            id: group.groupId,
            name: group.name,
          }));
         
         
          this.groupDropDown=this.VendorGroupArray.filter(group=>group.isActive==1);  
          this.vendorMap=this.groupDropDown.map((group=>group.groupId));
          console.log('Vendor Map',this.vendorMap);
          }
          else {
            // this.isLoading = false;
            Swal.fire({
              title: data.statusMessage,
              icon: "warning",
              showCloseButton: true,
              allowOutsideClick: false
            });
            this.spinnerService.hide();
  
          }
        },
        err => {
          if (err.status === 401) {
            this.spinnerService.hide();
            this.unauthorizedException();
          }
        }
      );
    }
  checkAllFieldsEnteredSharepoint(): boolean {
      return Object.keys(this.sharePointForm.controls).every(controlName => {
        if (controlName === 'notes') {
          // Skip validation for the "notes" field
          return true;
        }
        else if(controlName=='catagory' && !this.isPresent ){
          return true;
        }
        else if(controlName=='subcatogorycatagory'  && this.isPresent){
          if(this.subcategoryMap.length!=0){
            return true;
          }
          const control = this.sharePointForm.get(controlName);
         
          // if(control.value==0 && this.disable){
          //   return true;
          // }
           if(control.value==0){
            return false;
          }
          return true;
          }
         
        else if(controlName=='groupId'){
          return true;
        }
        const control = this.sharePointForm.get(controlName);
        return control.value !== '' && control.value !== null;
      });
    }
  checkAllFieldsEntereds(){
     
        return Object.keys(this.announcementForm.controls).every(controlName => {
          if (controlName === 'notes') {
            // Skip validation for the "notes" field
            return true;
          }
          if(controlName=="sharePointLink"){
            return true;
          }
          else if(controlName=='catagory' && !this.isPresent ){
            return true;
          }
          else if(controlName=='subcatogorycatagory'  && this.isPresent){
            // console.log("Abc");
            if(this.subcategoryMap.length!=0){
              return true;
            }
            const control = this.announcementForm.get(controlName);
          //  console.log('Control',control);
            // if(control.value==0 && this.disable){
            //   return true;
            // }
             if(control.value==0){
              return false;
            }
            return true;
            }
           
          else if(controlName=='groupId'){
            return true;
          }
     
          const control = this.announcementForm.get(controlName);
          // console.log(control?.value,controlName);
          return control?.value !== '' && control?.value !== null;
        });
      
    }
  openAddMemberModal() {
    this.isPresent=false;
    $("#newMemberCreate").modal("show");
    this.addMemberForm = true;
    this.memberForm = this.formBuilder.group({
      firstName: ["", [Validators.required, WhiteSpaceValidator, Validators.pattern(/^(?=.*[a-zA-Z].*[a-zA-Z])[a-zA-Z\s]{3,}$/)]],
      lastName: ["", [Validators.required, Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z\s]*$/)]],
      title: ["", [Validators.required, WhiteSpaceValidator, Validators.pattern(/^[a-zA-Z0-9,._ -]*$/), Validators.minLength(2)]],
      organaisationName: [this.organizationName],
      email: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
        ]
      ],
      phoneNo: ["", [Validators.required, Validators.pattern(/^[1-9][0-9]{9}$/)]],
      // address: ["", [Validators.required, WhiteSpaceValidator]],
      // city: ["", [Validators.required, WhiteSpaceValidator]],
      roleType: ['', [Validators.required]],
      parentCategoryId:[0],
      subCategoryId:[0]
      // zipCode: ["", [Validators.required, Validators.pattern(/^[0-9]{5}$/)]],
      // interval: ["year"]
    });
    console.log('Checking role ', this.roleTypes[0].role);
  }
  oncatogorySelect(event:any){
    let subcatogoryList=  this.subCatagoryDropDown;
    this.isPresent=false;
    console.log('s',this.subCatagoryDropDowns);
    console.log('Event',(event.target as HTMLSelectElement).value);
    console.log('Subcatogory',this.subCatagoryDropDown);
    this.subCatagoryDropDown=  this.subCatagoryDropDowns.filter(
    (x) => x.parentCategoryId == (event.target as HTMLSelectElement).value
    );
    subcatogoryList=this.subcategoryDropDowns;
    // subcatogoryList=this.subCatagoryDropDown;
    
    console.log('subcatogory',this.subCatagoryDropDown);
    this.isPresent=  this.subCatagoryDropDown.length==0?false:true;
  }
  getRoles() {
    if (this.roleList) {
      return this.roleList;
    }

    this.memberService
      .getRoleValues(this.token)
      .subscribe(
        data => {
          this.roleList = data;
          this.roleTypes = this.roleList.roleType

        },
        err => {
          if (err.status === 401) {
            this.unauthorizedException();
            this.spinnerService.hide();
          }
        }
      );
  }
  unauthorizedException() {
      Swal.fire({
        icon: "warning",
        title: "Session Expired!",
        allowOutsideClick: false,
        confirmButtonColor: "#d33",
        confirmButtonText: "Logout"
      }).then(() => {
        localStorage.clear();
        this.router.navigate(["/login"]);
      });
      return;
    }
  toggleRoleSelection(role: string) {
      console.log('',role);
      
      this.userRoles.push(role);
     
      const index = this.selectedRoles.indexOf(role);
      if (index === -1) {
        // Role is not in the array, add it
        this.selectedRoles.push(role);
      } else {
        // Role is already in the array, remove it
        this.selectedRoles.splice(index, 1);
      }
      if (this.selectedRoles.length > 0) {
        this.isSelectedRoles = false
      }
      else {
        this.isSelectedRoles = true
      }
    }

}



